/**
 * Table of bulk RMA action requests for one store. Row click opens the request detail view.
 */
import { observer } from 'mobx-react-lite';

import Table from '../../../../../../components/table/table';
import { IColumn } from '../../../../../../components/table/table.types';
import { IBulkRmaActionRequestSummary } from '../../../../../../services/api/troubleshooting-service';
import bulkRmaActionRequestsPagedListStore from '../../stores/bulk-rma-action-requests-paged-list-store';
import bulkRmaActionRequestDetailStore from '../../stores/bulk-rma-action-request-detail-store';
import RequestTableRow from './request-table-row';

interface IRequestsTableProps {
    storeId: string | number;
    requests: IBulkRmaActionRequestSummary[];
}

const REQUESTS_COLUMNS: IColumn[] = [
    { content: 'ID', width: { value: 72, type: 'px' } },
    { content: 'Action', width: { value: 120, type: 'px' } },
    { content: 'Status', width: { value: 110, type: 'px' } },
    { content: 'Total', width: { value: 1, type: 'fr' } },
    { content: 'Unresolved', width: { value: 1, type: 'fr' } },
    { content: 'Succeeded', width: { value: 1, type: 'fr' } },
    { content: 'Blocked', width: { value: 1, type: 'fr' } },
    { content: 'Errors', width: { value: 1, type: 'fr' } },
    { content: 'Created', width: { value: 140, type: 'px' } },
    { content: 'Last progress', width: { value: 140, type: 'px' } },
    { content: 'Finished', width: { value: 140, type: 'px' } },
];

const RequestsTable: React.FC<IRequestsTableProps> = observer(({ storeId, requests }) => {
    const onSelectRequest = (requestId: number) => {
        void bulkRmaActionRequestDetailStore.open(storeId, requestId);
    };

    return (
        <div className="bulk-rma-actions-page__table-wrapper">
            <Table columns={REQUESTS_COLUMNS}>
                {requests.map((request) => {
                    const unresolved =
                        bulkRmaActionRequestsPagedListStore.unresolvedReturns[request.request_id] ?? 0;

                    return (
                        <RequestTableRow
                            key={request.request_id}
                            request={request}
                            unresolved={unresolved}
                            onSelect={onSelectRequest}
                        />
                    );
                })}
            </Table>
        </div>
    );
});

export default RequestsTable;
